import ButtonDesigned from '@components/UI-Elements/Buttons/ButtonDesigned';
import { TrashIcon, TYPE_TO_NOTIFICATION_ICON_MAP } from './NotificationIcons';
import React from 'react';
import { CircularProgress } from '@mui/material';

export const ColorBorder: React.FC<{ color: string }> = ({ color }) => (
  <div
    className="flex py-[1.125rem] border-l-2"
    style={{
      borderLeft: `0.375rem solid ${color || 'transparent'}`,
    }}
  ></div>
);

export const NotificationIcon: React.FC<{
  type: string;
  color?: string;
  onDelete?: () => void;
  hovered: boolean;
  isLoading: boolean;
}> = ({ type, color = 'black', onDelete, hovered, isLoading }) => {
  const { icon: Icon, color: staticColor } = TYPE_TO_NOTIFICATION_ICON_MAP[type];

  return (
    <div className="flex flex-col  justify-between items-start w-8 ">
      <Icon iconColor={staticColor || color} />

      {onDelete && hovered && <TrashOrLoading delete={onDelete} isLoading={isLoading} />}
    </div>
  );
};

export const TrashOrLoading: React.FC<{ delete: () => void; isLoading: boolean }> = ({ delete: onClick, isLoading }) =>
  isLoading ? <CircularProgress size={20} /> : <TrashIcon iconColor="#6571FF" onClick={onClick} />;

export const NotificationBody: React.FC<{
  text: string;
  expanded: boolean;
  setExpanded: (_expanded: boolean) => void;
  desc?: string;
}> = ({ text, expanded, setExpanded, desc }) => (
  <>
    <div className="flex flex-row justify-between">
      <p className="overflow-ellipsis text-sm cursor-pointer">{text}</p>
    </div>
    {desc && (
      <p
        className={`text-xs leading-4 opacity-80 gray-700 cursor-pointer ${expanded ? '' : ' max-h-5 overflow-hidden'}`}
      >
        {desc}
      </p>
    )}
  </>
);

export const ActionSection: React.FC<{
  text: string;
  onAction: () => void;
  isLoading: boolean;
}> = ({ text, onAction, isLoading }) =>
  text && (
    <ButtonDesigned
      disableButton={isLoading}
      onButtonClick={onAction}
      style="outline"
      className="w-36 mx-auto mt-2"
      isFunctionLoading={isLoading}
    >
      {text}
    </ButtonDesigned>
  );
